const connectKYCText = (ffOrg) => {
  return `You are not connected with ${ffOrg}.`;
};

const addKYCText = (ffOrg) => {
  return `To book your shipment, first share KYC details & send request to ${ffOrg} for the connection.`;
};

export {
  addKYCText,
  connectKYCText,
};
